import { useTranslation } from "react-i18next";
import { SortOrder } from "../../../../components/provider/DtsAppContextProvider";
import { FilterItem } from "../../../../components/provider/DtsAppContextProvider";
import { FaMinus, FaPlus } from "react-icons/fa6";

interface SearchHistoryAccordionMenuProps {
  open: boolean;
  sortOrder: SortOrder;
  filterItem: FilterItem;
  filterCriteria: string;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setSortOrder: React.Dispatch<React.SetStateAction<SortOrder>>;
  setFilterItem: React.Dispatch<React.SetStateAction<FilterItem>>;
  setFilterCriteria: React.Dispatch<React.SetStateAction<string>>;
  handleOnApply: () => Promise<void>;
}

export const SearchHistoryAccordionMenu: React.FC<
  SearchHistoryAccordionMenuProps
> = ({
  open,
  sortOrder,
  filterItem,
  filterCriteria,
  setOpen,
  setSortOrder,
  setFilterItem,
  setFilterCriteria,
  handleOnApply,
}) => {
  //言語切替用
  const { t } = useTranslation();

  //フィルター項目が変化したときの処理
  const handleSelectFilterItem = (filterItem: FilterItem) => {
    //フィルター条件をリセット
    setFilterCriteria("");
    setFilterItem(filterItem);
    //回答状況を選択した場合, 初期値として未完了(incomplete)をセットする
    if (filterItem === "status") {
      setFilterCriteria("0");
    }
  };

  //フィルター条件が変化したときの処理
  const handleSelectSearchItem = (searchItem: string) => {
    setFilterCriteria(searchItem);
  };

  //表示設定(1層目)をレンダリングする関数
  const renderDisplaySetting = () => {
    return (
      <div
        className="flex items-center py-2 bg-white border border-gray-500"
        onClick={() => setOpen((prevState) => !prevState)}
      >
        <div className="pl-3 pr-5">{open ? <FaMinus /> : <FaPlus />}</div>
        <p className="">{t("検索履歴画面.表示設定")}</p>
      </div>
    );
  };

  //詳細内容(2層目)をレンダリングする関数
  const renderSearchMenu = () => {
    return (
      <div className="bg-white border border-t-0 border-gray-500 shadow-md">
        <div className="pr-6 pl-12 py-2">
          <div className="flex flex-col mb-2">
            <p className="text-nowrap">
              {t("検索履歴画面.並び順")} :{/* 並び順 */}
            </p>
            <select
              name="line"
              className="grow min-w-0 text-black bg-white border border-sub-blue rounded ml-1 p-1 h-7"
              onChange={(e) => setSortOrder(e.target.value as SortOrder)}
              value={sortOrder}
            >
              <option value={"desc"}>
                {t("検索履歴画面.検索日時-降順")}
                {/* 検索日時-降順 */}
              </option>
              <option value={"asc"}>
                {t("検索履歴画面.検索日時-昇順")}
                {/* 検索日時-昇順 */}
              </option>
            </select>
          </div>
          <div className="flex flex-col mb-2">
            <p className="text-nowrap">{t("検索履歴画面.フィルター項目")} :</p>
            {/* フィルター項目 */}
            <select
              name="filter"
              className="grow text-black bg-white border border-sub-blue rounded ml-1 p-1 h-7"
              value={filterItem}
              onChange={(e) =>
                handleSelectFilterItem(e.target.value as FilterItem)
              }
            >
              <option value={""}>
                {t("検索履歴画面.選択なし")}
                {/* 選択なし */}
              </option>
              <option value={"subjectName"}>
                {t("検索履歴画面.案件名")}
                {/* 案件名 */}
              </option>
              <option value={"model"}>
                {t("検索履歴画面.型式")}
                {/* 型式 */}
              </option>
              <option value={"machineNumber"}>
                {t("検索履歴画面.機番")}
                {/* 機番 */}
              </option>
              <option value={"status"}>
                {t("検索履歴画面.回答状況")}
                {/* 回答状況 */}
              </option>
            </select>
          </div>
          <div className="flex flex-col mb-2">
            <p className="text-nowrap">
              {t("検索履歴画面.フィルター条件")} :{/* フィルター条件 */}
            </p>
            {filterItem === "status" ? (
              <select
                className="grow text-black bg-white border border-sub-blue rounded ml-1 p-1 h-7"
                onChange={(e) => handleSelectSearchItem(e.target.value)}
                value={filterCriteria}
              >
                <option value={"0"}>
                  {t("検索履歴画面.未完了")}
                  {/* 未完了 */}
                </option>
                <option value={"1"}>
                  {t("検索履歴画面.完了")}
                  {/* 完了 */}
                </option>
              </select>
            ) : (
              <input
                className={`grow text-black ${
                  filterItem ? "bg-white" : "bg-gray-300"
                } border border-sub-blue rounded ml-1 p-1 h-7`}
                onChange={(e) => handleSelectSearchItem(e.target.value)}
                value={filterCriteria}
                disabled={!filterItem}
              />
            )}
          </div>
        </div>
        <div className="flex justify-center mb-4">
          <button
            disabled={
              !(
                (filterItem !== "" && filterCriteria !== "") ||
                (filterItem === "" && filterCriteria === "")
              )
            }
            className={
              (filterItem !== "" && filterCriteria !== "") ||
              (filterItem === "" && filterCriteria === "")
                ? "border border-gray-500 rounded-full bg-white px-2 py-1 min-w-20 overflow-hidden w-40 whitespace-nowrap"
                : "border border-gray-500 rounded-full bg-gray-300 text-gray-500 px-2 py-1 min-w-20 overflow-hidden w-40 whitespace-nowrap"
            }
            onClick={handleOnApply}
          >
            {t("検索履歴画面.適用")}
            {/* 適用 */}
          </button>
        </div>
      </div>
    );
  };

  //各リストを連結
  const renderMenu = () => {
    return (
      <>
        {renderDisplaySetting()}
        {open && renderSearchMenu()}
      </>
    );
  };

  return <div className="mb-4">{renderMenu()}</div>;
};
